function setMainBgOffset() {
  const bannerSection = document.querySelector('section[id$="__slideshow_8MEfh4"]');
  const banner = bannerSection?.querySelector('x-slideshow') || bannerSection;
  const main = document.querySelector('main#main.anchor');

  if (!banner || !main) return;

  const bannerHeight = banner.getBoundingClientRect().height;

  if (bannerHeight > 0) {
    main.style.setProperty('--banner-height', `${bannerHeight}px`);
    main.classList.add('is-bg-ready');
  }
}

window.addEventListener('DOMContentLoaded', setMainBgOffset);
window.addEventListener('load', setMainBgOffset);
window.addEventListener('resize', setMainBgOffset);

setTimeout(setMainBgOffset, 300);
setTimeout(setMainBgOffset, 1000);
